/** Axios instance with credentialed cookies and a 401 → /sign-in redirect.
 *  Mirrors tenant-frontend's QueryManager basics (JWT-cookie + auto-logout). */
import axios, {type AxiosError, type AxiosInstance} from "axios";

const apiClient: AxiosInstance = axios.create({
    baseURL: "/api/v1",
    withCredentials: true,
    headers: {"Content-Type": "application/json"},
});

let onUnauthorized: (() => void) | null = null;

export function setUnauthorizedHandler(handler: () => void): void {
    onUnauthorized = handler;
}

apiClient.interceptors.response.use(
    (r) => r,
    (err: AxiosError) => {
        if (err.response?.status === 401 && onUnauthorized) {
            onUnauthorized();
        }
        return Promise.reject(err);
    },
);

export default apiClient;
